import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000, withCredentials: true });

api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status === 401 && !cfg._retried && !cfg.url.startsWith("/auth/")) {
    cfg._retried = true;
    try {
      await api.post("/auth/refresh");
      return api(cfg);
    } catch {
      /* fall through */
    }
  }
  return Promise.reject(error);
});

export const createJourney = (character) =>
  api.post("/journey", { character }).then((r) => r.data);

export const getJourney = (id) => api.get(`/journey/${id}`).then((r) => r.data);

export const explore = (id, question) =>
  api.post(`/journey/${id}/explore`, { question }).then((r) => r.data);

export const decide = (id, question, chosen) =>
  api.post(`/journey/${id}/decide`, { question, chosen }).then((r) => r.data);

export const mirror = (id, years) =>
  api.post(`/journey/${id}/mirror`, { years }).then((r) => r.data);

export const chat = (id, message, history, years) =>
  api.post(`/journey/${id}/chat`, { message, history, years }).then((r) => r.data);

export const uploadPhoto = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/journey/${id}/photo`, fd).then((r) => r.data);
};

export const agePhoto = (id, years) =>
  api.post(`/journey/${id}/age-photo`, { years }).then((r) => r.data);

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const plan = (id, future_title, future_summary) =>
  api.post(`/journey/${id}/plan`, { future_title, future_summary }).then((r) => r.data);

export const compare = (id, futures) =>
  api.post(`/journey/${id}/compare`, { futures }).then((r) => r.data);

export const saveFuture = (id, future) =>
  api.post(`/journey/${id}/save`, future).then((r) => r.data);

export const reflectQuestion = (id) =>
  api.post(`/journey/${id}/reflect`).then((r) => r.data);

export const reflectAnswer = (id, question, answer, years) =>
  api.post(`/journey/${id}/reflect/answer`, { question, answer, years }).then((r) => r.data);
